module.exports = __webpack_public_path__ + "static/media/PM59.6e01107b.png";